export const Escribano_item = [
    {
        "anio": "2025",
        "Escribanos": [
            {
                "Escribano": "Publicaciones",
                "url": "",
                "Extras": [

                    {
                        "NombreValor": "Enero",
                        "url2": "/pdf/Escribano/2025/Enero.pdf"
                    },
                    {
                        "NombreValor": "Febrero",
                        "url2": "/pdf/Escribano/2025/Febrero.pdf"
                    },
                    {
                        "NombreValor": "Marzo",
                        "url2": "/pdf/Escribano/2025/Marzo.pdf"
                    },
                     {
                        "NombreValor": "Abril",
                        "url2": "/pdf/Escribano/2025/Abril.pdf"
                    },
                    {
                        "NombreValor": "Mayo",
                        "url2": "/pdf/Escribano/2025/Mayo.pdf"
                    },
                     {
                        "NombreValor": "Junio",
                        "url2": "/pdf/Escribano/2025/Junio.pdf"
                    },
                     {
                        "NombreValor": "Julio",
                        "url2": "/pdf/Escribano/2025/Julio.pdf"
                    },
                  {
                        "NombreValor": "Agosto",
                        "url2": "/pdf/Escribano/2025/Agosto.pdf"
                    },
                   
                ]
            }
        ]
    },
    {
        "anio": "2024",
        "Escribanos": [
            {
                "Escribano": "Publicaciones",
                "url": "",
                "Extras": [

                    {
                        "NombreValor": "Enero",
                        "url2": "/pdf/Escribano/2024/Enero.pdf"
                    },
                    {
                        "NombreValor": "Febrero",
                        "url2": "/pdf/Escribano/2024/Febrero.pdf"
                    },
                    {
                        "NombreValor": "Marzo",
                        "url2": "/pdf/Escribano/2024/Marzo.pdf"
                    },
                    {
                        "NombreValor": "Abril",
                        "url2": "/pdf/Escribano/2024/Abril.pdf"
                    },
                    {
                        "NombreValor": "Mayo",
                        "url2": "/pdf/Escribano/2024/Mayo.pdf"
                    },
                    {
                        "NombreValor": "Junio",
                        "url2": "/pdf/Escribano/2024/Junio.pdf"
                    },
                    {
                        "NombreValor": "Julio",
                        "url2": "/pdf/Escribano/2024/Julio.pdf"
                    },
                    {
                        "NombreValor": "Agosto",
                        "url2": "/pdf/Escribano/2024/Agosto.pdf"
                    },
                    {
                        "NombreValor": "Septiembre",
                        "url2": "/pdf/Escribano/2024/Septiembre.pdf"
                    },
                    {
                        "NombreValor": "Octubre",
                        "url2": "/pdf/Escribano/2024/Octubre.pdf"
                    },
                    {
                        "NombreValor": "Noviembre",
                        "url2": "/pdf/Escribano/2024/Noviembre.pdf"
                    },
                    {
                        "NombreValor": "Diciembre",
                        "url2": "/pdf/Escribano/2024/Diciembre.pdf"
                    },
                   
                ]
            }
        ]
    },
    {
        "anio": "2023",
        "Escribanos": [
            {
                "Escribano": "Publicaciones",
                "url": "",
                "Extras": [

                    {
                        "NombreValor": "Enero",
                        "url2": "/pdf/Escribano/2023/Enero.pdf"
                    },
                    {
                        "NombreValor": "Febrero",
                        "url2": "/pdf/Escribano/2023/Febrero.pdf"
                    },
                    {
                        "NombreValor": "Marzo",
                        "url2": "/pdf/Escribano/2023/Marzo.pdf"
                    },
                    {
                        "NombreValor": "Abril",
                        "url2": "/pdf/Escribano/2023/Abril.pdf"
                    },
                    {
                        "NombreValor": "Mayo",
                        "url2": "/pdf/Escribano/2023/Mayo.pdf"
                    },
                    {
                        "NombreValor": "Junio",
                        "url2": "/pdf/Escribano/2023/Junio.pdf"
                    },
                    {
                        "NombreValor": "Julio",
                        "url2": "/pdf/Escribano/2023/Julio.pdf"
                    },
                    {
                        "NombreValor": "Agosto",
                        "url2": "/pdf/Escribano/2023/Agosto.pdf"
                    },
                    {
                        "NombreValor": "Septiembre",
                        "url2": "/pdf/Escribano/2023/Septiembre.pdf"
                    },
                    {
                        "NombreValor": "Octubre",
                        "url2": "/pdf/Escribano/2023/Octubre.pdf"
                    },
                    {
                        "NombreValor": "Noviembre",
                        "url2": "/pdf/Escribano/2023/Noviembre.pdf"
                    },
                    {
                        "NombreValor": "Diciembre",
                        "url2": "/pdf/Escribano/2023/Diciembre.pdf"
                    }
                ]
            }
        ]
    },
    {
        "anio": "2022",
        "Escribanos": [
            {
                "Escribano": "Publicaciones",
                "url": "",
                "Extras": [

                    {
                        "NombreValor": "Enero",
                        "url2": "/pdf/Escribano/2022/Enero.pdf"
                    },
                    {
                        "NombreValor": "Febrero",
                        "url2": "/pdf/Escribano/2022/Febrero.pdf"
                    },
                    {
                        "NombreValor": "Marzo",
                        "url2": "/pdf/Escribano/2022/Marzo.pdf"
                    },
                    {
                        "NombreValor": "Abril",
                        "url2": "/pdf/Escribano/2022/Abril.pdf"
                    },
                    {
                        "NombreValor": "Mayo",
                        "url2": "/pdf/Escribano/2022/Mayo.pdf"
                    },
                    {
                        "NombreValor": "Junio",
                        "url2": "/pdf/Escribano/2022/Junio.pdf"
                    },
                    {
                        "NombreValor": "Julio",
                        "url2": "/pdf/Escribano/2022/Julio.pdf"
                    },
                    {
                        "NombreValor": "Agosto",
                        "url2": "/pdf/Escribano/2022/Agosto.pdf"
                    },
                    {
                        "NombreValor": "Septiembre",
                        "url2": "/pdf/Escribano/2022/Septiembre.pdf"
                    },
                    {
                        "NombreValor": "Octubre",
                        "url2": "/pdf/Escribano/2022/Octubre.pdf"
                    },
                    {
                        "NombreValor": "Noviembre",
                        "url2": "/pdf/Escribano/2022/Noviembre.pdf"
                    },
                    {
                        "NombreValor": "Diciembre",
                        "url2": "/pdf/Escribano/2022/Diciembre.pdf"
                    }
                ]
            }
        ]
    },
    {
        "anio": "2021",
        "Escribanos": [
            {
                "Escribano": "Publicaciones",
                "url": "",
                "Extras": [
                    {
                        "NombreValor": "Enero",
                        "url2": "/pdf/Escribano/2021/Enero.pdf"
                    },
                    {
                        "NombreValor": "Febrero",
                        "url2": "/pdf/Escribano/2021/Febrero.pdf"
                    },
                    {
                        "NombreValor": "Marzo",
                        "url2": "/pdf/Escribano/2021/Marzo.pdf"
                    },
                    {
                        "NombreValor": "Abril",
                        "url2": "/pdf/Escribano/2021/Abril.pdf"
                    },
                    {
                        "NombreValor": "Mayo",
                        "url2": "/pdf/Escribano/2021/Mayo.pdf"
                    },
                    {
                        "NombreValor": "Junio",
                        "url2": "/pdf/Escribano/2021/Junio.pdf"
                    },
                    {
                        "NombreValor": "Julio",
                        "url2": "/pdf/Escribano/2021/Julio.pdf"
                    },
                    {
                        "NombreValor": "Agosto",
                        "url2": "/pdf/Escribano/2021/Agosto.pdf"
                    },
                    {
                        "NombreValor": "Septiembre",
                        "url2": "/pdf/Escribano/2021/Septiembre.pdf"
                    },
                    {
                        "NombreValor": "Octubre",
                        "url2": "/pdf/Escribano/2021/Octubre.pdf"
                    },
                    {
                        "NombreValor": "Noviembre",
                        "url2": "/pdf/Escribano/2021/Noviembre.pdf"
                    },
                    {
                        "NombreValor": "Diciembre",
                        "url2": "/pdf/Escribano/2021/Diciembre.pdf"
                    }
                ]
            },
           
        ]
    },
    {
        "anio": "2020",
        "Escribanos": [
            {
                "Escribano": "Publicaciones",
                "url": "",
                "Extras": [
                    {
                        "NombreValor": "Enero",
                        "url2": "/pdf/Escribano/2020/Enero.pdf"
                    },
                    {
                        "NombreValor": "Febrero",
                        "url2": "/pdf/Escribano/2020/Febrero.pdf"
                    },
                    {
                        "NombreValor": "Marzo",
                        "url2": "/pdf/Escribano/2020/Marzo.pdf"
                    },
                    {
                        "NombreValor": "Abril",
                        "url2": "/pdf/Escribano/2020/Abril.pdf"
                    },
                    {
                        "NombreValor": "Mayo",
                        "url2": "/pdf/Escribano/2020/Mayo.pdf"
                    },
                    {
                        "NombreValor": "Junio",
                        "url2": "/pdf/Escribano/2020/Junio.pdf"
                    },
                    {
                        "NombreValor": "Julio",
                        "url2": "/pdf/Escribano/2020/Julio.pdf"
                    },
                    {
                        "NombreValor": "Agosto",
                        "url2": "/pdf/Escribano/2020/Agosto.pdf"
                    },
                    {
                        "NombreValor": "Septiembre",
                        "url2": "/pdf/Escribano/2020/Septiembre.pdf"
                    },
                    {
                        "NombreValor": "Octubre",
                        "url2": "/pdf/Escribano/2020/Octubre.pdf"
                    },
                    {
                        "NombreValor": "Noviembre",
                        "url2": "/pdf/Escribano/2020/Noviembre.pdf"
                    },
                    {
                        "NombreValor": "Diciembre",
                        "url2": "/pdf/Escribano/2020/Diciembre.pdf"
                    }
                ]
            },
         
        ]
    },
    {
        "anio": "2019",
        "Escribanos": [
            {
                "Escribano": "Publicaciones",
                "url": "",
                "Extras": [
                    {
                        "NombreValor": "Enero",
                        "url2": "/pdf/Escribano/2019/Enero.pdf"
                    },
                    {
                        "NombreValor": "Febrero",
                        "url2": "/pdf/Escribano/2019/Febrero.pdf"
                    },
                    {
                        "NombreValor": "Marzo",
                        "url2": "/pdf/Escribano/2019/Marzo.pdf"
                    },
                    {
                        "NombreValor": "Abril",
                        "url2": "/pdf/Escribano/2019/Abril.pdf"
                    },
                    {
                        "NombreValor": "Mayo",
                        "url2": "/pdf/Escribano/2019/Mayo.pdf"
                    },
                    {
                        "NombreValor": "Junio",
                        "url2": "/pdf/Escribano/2019/Junio.pdf"
                    },
                    {
                        "NombreValor": "Julio",
                        "url2": "/pdf/Escribano/2019/Julio.pdf"
                    },
                    {
                        "NombreValor": "Agosto",
                        "url2": "/pdf/Escribano/2019/Agosto.pdf"
                    },
                    {
                        "NombreValor": "Septiembre",
                        "url2": "/pdf/Escribano/2019/Septiembre.pdf"
                    },
                    {
                        "NombreValor": "Octubre",
                        "url2": "/pdf/Escribano/2019/Octubre.pdf"
                    },
                    {
                        "NombreValor": "Noviembre",
                        "url2": "/pdf/Escribano/2019/Noviembre.pdf"
                    },
                  
                ]
            }
        ]
    },
    {
        "anio": "2018",
        "Escribanos": [
            {
                "Escribano": "Publicaciones",
                "url": "",
                "Extras": [
                    {
                        "NombreValor": "Enero",
                        "url2": "/pdf/Escribano/2018/Enero.pdf"
                    },
                    {
                        "NombreValor": "Febrero",
                        "url2": "/pdf/Escribano/2018/Febrero.pdf"
                    },
                    {
                        "NombreValor": "Marzo",
                        "url2": "/pdf/Escribano/2018/Marzo.pdf"
                    },
                    {
                        "NombreValor": "Abril",
                        "url2": "/pdf/Escribano/2018/Abril.pdf"
                    },
                    {
                        "NombreValor": "Mayo",
                        "url2": "/pdf/Escribano/2018/Mayo.pdf"
                    },
                    {
                        "NombreValor": "Junio",
                        "url2": "/pdf/Escribano/2018/Junio.pdf"
                    },
                    {
                        "NombreValor": "Julio",
                        "url2": "/pdf/Escribano/2018/Julio.pdf"
                    },
                    {
                        "NombreValor": "Agosto",
                        "url2": "/pdf/Escribano/2018/Agosto.pdf"
                    },
                    {
                        "NombreValor": "Septiembre",
                        "url2": "/pdf/Escribano/2018/Septiembre.pdf"
                    },
                    {
                        "NombreValor": "Octubre",
                        "url2": "/pdf/Escribano/2018/Octubre.pdf"
                    },
                    {
                        "NombreValor": "Noviembre",
                        "url2": "/pdf/Escribano/2018/Noviembre.pdf"
                    },
                    {
                        "NombreValor": "Diciembre",
                        "url2": "/pdf/Escribano/2018/Diciembre.pdf"
                    },
                ]
            },
         
        ]
    },
    {
        "anio": "2017",
        "Escribanos": [
            {
                "Escribano": "Publicaciones",
                "url": "",
                "Extras": [

                    {
                        "NombreValor": "Octubre",
                        "url2": "/pdf/Escribano/2017/Octubre.pdf"
                    },
                    {
                        "NombreValor": "Noviembre",
                        "url2": "/pdf/Escribano/2017/Noviembre.pdf"
                    },
                    {
                        "NombreValor": "Diciembre",
                        "url2": "/pdf/Escribano/2017/Diciembre.pdf"
                    },
                ]
            },
         
        ]
    }

]